define('TescoMobile_DynamicBundleOptions/js/dynamic-options/cca-price',['underscore', 'uiComponent', 'jquery', 'mage/translate', 'Magento_Catalog/js/price-utils', 'mage/template', 'TescoMobile_Catalog/js/model/deal', 'priceBox'], function (_, Component, $, $t, utils, mageTemplate, deal) {
  'use strict';
  return Component.extend({
    defaults: {
      pufOptionSelector: null,
      tenureOptionSelector: null,
      ccaPriceConfig: null,
      priceTemplate: '<span class="price"><%- data.formatted %></span>',
      priceBoxSelector: 'div.price-box.price-configured_price',
      priceHolderSelector: '[data-price-type]',
      pufBoxSelector: '[data-fieldname="dynamic_bundle_option[tm_puf]"]',
      currentAdjustment: 0,
      currentOptionKey: null,
      ccaConfig: null,
      puffAllOptionValue: null,
      isAuImmediate: false,
      minimumCcaPrice: 1,
      isForcedAuImmediate: false,
      tenureSuffix: $t('months'),
      selectedOptionId: null,
      selectedOptionValue: null,
      selectedPuf: null,
      selectedTenure: null,
      deviceMonthlyPrice: 0,
      deviceFullPrice: 0
    },
    initialize: function () {
      this._super();
      if (!$(this.pufOptionSelector).length || !$(this.tenureOptionSelector).length) {
        return;
      }
      this._maintainCcaMimumumPrice(this._getCcaConfig());
      $(document).on('DynamicOptionsPriceUpdateBefore', $.proxy(this._modifyPriceData, this));
      $(this.pufOptionSelector).on('change', $.proxy(function (event) {
        if ($(event.target).val() == this.puffAllOptionValue) {
          this._enableAuImmediate();
        } else {
          this._disableAuImmediate();
        }
      }, this));
      if (this._getUrlParam('puf') && this._getUrlParam('puf') === 'all' || $(this.pufBoxSelector + ' .field.choice.all .bundle-option-tm_puf').attr("checked") === 'checked') {
        var radioParentSelector = $(this.pufOptionSelector).parent(),
          allPuf = $('.all ' + this.pufOptionSelector);
        this._enableAuImmediate();
        $(document).trigger('DynamicOptionsPriceUpdateBefore');
        $(this.priceBoxSelector).trigger('updatePrice');
      }
      $(this.tenureOptionSelector).on('change', $.proxy(function (event) {
        $(this.priceBoxSelector).trigger('updatePrice');
        $(this.tenureOptionSelector).parent().parent().prev().children('.selected-price').text($(event.target).next().text() + this.tenureSuffix);
      }, this));
      $(this.pufOptionSelector).on('change', $.proxy(function (event) {
        $(this.priceBoxSelector).trigger('updatePrice');
        this._updateUpfrontLabel(event, $(this.pufOptionSelector).parent().parent().prev().children('.selected-price'));
      }, this));
      $(document).on('tm:deviceSwatchChanged', $.proxy(function (event) {
        $(this.priceBoxSelector).trigger('updatePrice');
        $(this.tenureOptionSelector).parent().parent().prev().children('.selected-price').text($(event.target).next().text() + this.tenureSuffix);
      }, this));
      this._updatePufFullPrice(this.deviceFullPrice);
      this.deviceFullPrice.subscribe(this._updatePufFullPrice, this);
      return this;
    },
    initObservable: function () {
      this._super().observe(['selectedOptionId', 'selectedOptionValue', 'selectedPuf', 'selectedTenure', 'deviceMonthlyPrice', 'deviceFullPrice']);
      return this;
    },
    _getUrlParam: function (type) {
      var getParams = window.location.search;
      if (getParams !== '') {
        var searchParams = new URLSearchParams(getParams.slice(1));
        return searchParams.get(type) ? searchParams.get(type) : false;
      }
      return false;
    },
    _modifyPriceData: function (event, newPrices, additionalPriceObject) {
      if (deal.isUpdatingOptions == true) {
        return;
      }
      if (!newPrices) {
        newPrices = additionalPriceObject;
      }
      _.each(newPrices, function (newPrice, priceOptionKey) {
        var optionId = this._getIdFromKey(priceOptionKey);
        var optionValue = this._getOptionValue(optionId);
        var ccaConfig = this._getCcaConfig(optionId, optionValue);
        this.selectedTenure(this._getSelectedTenure());
        this.selectedPuf(this._getSelectedPuf());
        if (ccaConfig) {
          this.currentOptionKey = priceOptionKey;
          this.ccaConfig = ccaConfig;
          this._maintainCcaMimumumPrice(ccaConfig);
          this.selectedOptionId(this._getIdFromKey(this.currentOptionKey));
          this.selectedOptionValue(this._getOptionValue(this.selectedOptionId()));
          this._updatePriceBoxPrice(newPrice, ccaConfig);
          if (ccaConfig.full_device_price) {
            this.deviceFullPrice(ccaConfig.full_device_price);
            deal.deviceFullPrice = this.deviceFullPrice();
          }
        } else {
          if (this.ccaConfig && this.currentOptionKey) {
            this.selectedOptionId(this._getIdFromKey(this.currentOptionKey));
            this.selectedOptionValue(this._getOptionValue(this.selectedOptionId()));
            this._updatePriceBoxPrice(additionalPriceObject[this.currentOptionKey], this.ccaConfig);
            if (this.ccaConfig.full_device_price) {
              this.deviceFullPrice(this.ccaConfig.full_device_price);
              deal.deviceFullPrice = this.deviceFullPrice();
            }
          }
        }
      }.bind(this));
      deal.puf = this.selectedPuf();
      deal.tenure = this.selectedTenure();
    },
    _getOptionValue: function (optionId) {
      return $('[name="bundle_option[' + optionId + ']"').val();
    },
    _enableAuImmediate: function () {
      $(this.tenureOptionSelector).attr('disabled', true);
      $(this.tenureOptionSelector).parents('.field.option').hide();
      $('.bundle-summary').hide();
      this.isAuImmediate = true;
    },
    _disableAuImmediate: function () {
      $(this.tenureOptionSelector).attr('disabled', false);
      $(this.tenureOptionSelector).parents('.field.option').show();
      $('.bundle-summary').show();
      this.isAuImmediate = false;
    },
    _forceAuImmediate: function () {
      this._enableAuImmediate();
      $(this.pufOptionSelector).val(this.puffAllOptionValue);
      $(this.pufOptionSelector).closest('.field').hide();
      this.isForcedAuImmediate = true;
    },
    _unforceAuImmediate: function () {
      this._disableAuImmediate();
      $(this.pufOptionSelector).prop('selectedIndex', 0);
      $(this.pufOptionSelector).closest('.field').show();
      this.isForcedAuImmediate = false;
    },
    _maintainCcaMimumumPrice: function (ccaConfig) {
      var currentTenure = $(this.tenureOptionSelector + ':checked').val();
      if (ccaConfig && ccaConfig['full'][currentTenure]) {
        var currentPuf = $(this.pufOptionSelector + ':checked').val();
        var radioParentSelector = $(this.pufOptionSelector).parent();
        var radioParentSelectorField = null;
        if (!ccaConfig['full_device_price']) {
          radioParentSelectorField = radioParentSelector.parent();
        }
        radioParentSelector.filter(function (option) {
          return !$(this).hasClass('all');
        }).remove();
        var newPufOptions = [];
        $.each(ccaConfig['full'][currentTenure], function (puf, ccaPrice) {
          if (ccaPrice > this.minimumCcaPrice) {
            var radio = $('<input />', {
              type: "radio",
              id: 'tm_puf_' + puf,
              name: radioParentSelectorField ? radioParentSelectorField.data('fieldname') : radioParentSelector.parent().data('fieldname'),
              value: puf,
              checked: puf == currentPuf ? 'checked' : false
            });
            var label = $('<label class="label" for="tm_puf_' + puf + '"><span>' + utils.formatPrice(puf, {
              precision: 0,
              requiredPrecision: 0
            }) + '</span></label>');
            newPufOptions.push($('<div />', {
              class: 'field choice',
              append: [radio, label]
            }));
          }
        }.bind(this));
        if (newPufOptions.length) {
          $.each(newPufOptions.reverse(), function (index, pufOption) {
            if (ccaConfig['full_device_price']) {
              $(radioParentSelector.parent()).prepend(pufOption);
            } else {
              $(radioParentSelectorField).prepend(pufOption);
            }
          }.bind(this));
          $(this.pufOptionSelector).off().on('change', $.proxy(function (event) {
            if ($(event.target).val() == this.puffAllOptionValue) {
              this._enableAuImmediate();
            } else {
              this._disableAuImmediate();
            }
            $(this.priceBoxSelector).trigger('updatePrice');
            const element = ccaConfig['full_device_price'] ? radioParentSelector.parent().prev().children('.selected-price') : radioParentSelectorField.prev().children('.selected-price');
            this._updateUpfrontLabel(event, element);
          }, this));
        } else {
          this._enableAuImmediate();
        }
      }
    },
    _updateUpfrontLabel: function (event, element) {
      element.html($(event.target).next().html());
    },
    _updatePriceBoxPrice: function (priceStore, ccaConfig) {
      if (priceStore) {
        var adjustmentValue;
        if (priceStore.finalPrice.amount <= 0) {
          this._forceAuImmediate();
        } else {
          if (this.isForcedAuImmediate == true) {
            this._unforceAuImmediate();
          }
        }
        if (this.isAuImmediate == false) {
          adjustmentValue = ccaConfig['delta'][this._getSelectedTenure()][this._getSelectedPuf()];
        } else {
          adjustmentValue = -priceStore.finalPrice.amount;
        }
        if (priceStore.finalPrice.adjustments) {
          priceStore.finalPrice.adjustments.ccaDelta = adjustmentValue;
        } else {
          priceStore.finalPrice.adjustments = {
            ccaDelta: adjustmentValue
          };
        }
        if (this.isAuImmediate === false) {
          this.deviceMonthlyPrice(ccaConfig['full'][this._getSelectedTenure()][this._getSelectedPuf()]);
        } else {
          this.deviceMonthlyPrice(0.);
        }
        deal.deviceMonthlyPrice = this.deviceMonthlyPrice();
      }
    },
    _getCcaConfig: function (optionId, optionValue) {
      const selectedOptionId = optionId || Object.keys(this.ccaPriceConfig)[0];
      if (!this.ccaPriceConfig[selectedOptionId]) {
        return null;
      }
      const selectedOptionValue = optionValue || this.ccaPriceConfig[selectedOptionId][0];
      if (!this.ccaPriceConfig[selectedOptionId][selectedOptionValue]) {
        return null;
      }
      this.selectedOptionId(selectedOptionId);
      this.selectedOptionValue(selectedOptionValue);
      return {
        'full': $(this.ccaPriceConfig[selectedOptionId][selectedOptionValue]['full']).get(0),
        'delta': $(this.ccaPriceConfig[selectedOptionId][selectedOptionValue]['delta']).get(0),
        'full_device_price': this.ccaPriceConfig[selectedOptionId][selectedOptionValue]['full_device_price']
      };
    },
    _getSelectedPuf: function () {
      return $(this.pufOptionSelector + ':checked').val();
    },
    _getSelectedTenure: function () {
      return $(this.tenureOptionSelector + ':checked').val();
    },
    _getIdFromKey: function (keyString) {
      return keyString.replace(/\D/g, '');
    },
    _updatePufFullPrice: function (deviceFullPrice) {
      const puf = `
<span class="full-price-wrapper">
    <span class="full-price-label">${$t('Full price')}</span>
    <span class="full-price-value">${utils.formatPrice(deviceFullPrice)}</span>
</span>`;
      if (this.selectedPuf() === 'all') {
        $("input[name='dynamic_bundle_option[tm_puf]']").closest('.fieldset-tm-bundle-options').find('.puf-price.selected-price').html(puf);
      }
      $(this.pufOptionSelector).parent('.all').find('label').html(puf);
    }
  });
});

